<template>
    <div class="i-page i-page-fix-top-bottom">
        <div class="title">{{title}}</div>
        <div class="meta_content">
            <span>{{source}}</span>
            <span class="right">{{create_time}}</span>
        </div>
        <div class="video" v-html="video_url"></div>
        <div class="content" v-html="desc"></div>
    </div>
</template>
<script>
    import {publicNewsDetail} from '../../api/news';

    export default {
        name: "newsDetail",
        data() {
            return {
                title: '',
                desc: '',
                source: '',
                create_time: '',
                video_url: '',
            };
        },
        mounted() {
            let _this = this;
            publicNewsDetail({id: this.$route.query.id})
                .then(res => {
                    if (res.code === 1) {
                        _this.title = document.title = res.content.title;
                        _this.desc = res.content.content;
                        _this.source = res.content.source;
                        _this.create_time = res.content.create_time;
                        _this.video_url = res.content.video_url && '<iframe src="' + res.content.video_url + '" frameborder=0 allowfullscreen></iframe>';
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        }
    };

</script>
<style lang="scss" scoped>
    .title {
        font-size: 15px;
        font-weight: bold;
        text-align: center;
        color: #333;
    }
    .meta_content {
        width: 100%;
        padding: 25px 0;
        float: left;
    }
    .meta_content span {
        font-size: 12px;
        padding: 0 20px;
        color: #999;
        float: left;
    }
    .meta_content span.right {
        float: right;
    }

    .content {
        font-size: 14px;
        margin: 8px;
        line-height: 2;
        color: #333;
    }

    .video {
        width: 90%;
        margin: 0 auto;
    }

    .i-page {
        height: 100vh;
        min-height: auto;
        padding: 20px 0;
    }

    .i-card-item:nth-last-of-type(1),
    .i-card-item:nth-last-of-type(2) {
        margin-bottom: $m8/2;
    }
</style>

<style scoped>
    .video /deep/ iframe {
        width: 100%;
        height: 220px;
    }
</style>